export class ErrorManager {
    errorBox = false;
    showBox(description) {
        this.errorBox = true;
        console.warn(description);
        return description;
    }
    getErrorBox() {
        return this.errorBox;
    }
    setErrorBox(errorBox) {
        this.errorBox = errorBox;
    }
}
export const errorManager = new ErrorManager();
//# sourceMappingURL=ErrorManager.js.map